import { render } from "./Monthly.vue?vue&type=template&id=d8366a54"
import script from "./Monthly.vue?vue&type=script&lang=js"
export * from "./Monthly.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__